import { useNavigate } from "@tanstack/react-router";

import { JoinSpacesButtonView } from "./JoinSpacesButtonView";

export interface JoinSpacesButtonProps {
  spaceGroupSlug: string;
}

export const JoinSpacesButton = ({ spaceGroupSlug }: JoinSpacesButtonProps) => {
  const navigate = useNavigate();

  const goToSpaceGroup = () => {
    void navigate({ to: `/s/$spaceGroupSlug`, params: { spaceGroupSlug } });
  };

  return <JoinSpacesButtonView onClick={goToSpaceGroup} />;
};
